import type { IOrganisation } from "@bbj-types/organisation";
import { TimeZone } from "@bbj-types/organisation/enum";
import { type ReactNode, createContext, useContext } from "react";

type I18nValue = NonNullable<IOrganisation["configuration"]["i18n"]>;

export const defaultI18nValue: I18nValue = { timeZone: TimeZone.EUROPE_PARIS, phoneCode: "FR" };

const I18nContext = createContext<I18nValue>(defaultI18nValue);

export const useI18nContext = () => useContext(I18nContext);

export const I18nProvider = ({ children, value }: { children: ReactNode; value: I18nValue }) => (
  <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
);
